<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lsrgs">
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Chondroitin Sulfate</span>
        </b>
        <b>
          <span style="font-size:16.0pt;font-family:Arial;"></span>
        </b>
        <b>
          <span style="font-size:18px;font-family:宋体;"></span>
        </b>
        <b>
          <span style="font-size:18px;font-family:Arial;">85%</span>
        </b>
        <b>
          <span style="font-size:12.0pt;font-family:Arial;"></span>
        </b>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:Arial;">
            <br>
          </span>
        </b>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Spec</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Purity
            :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &gt;85% by CPC and HPLC dry basis
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Appearance
            (Visual):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; White powder
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12px;font-family:Arial;">
          Clarity and color of
          Solution: 0.35 max.at 420nm
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12px;font-family:Arial;">
          Moisture:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6% - 10% USP
          (921) Karl Fischer
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Particle
          Size:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 100% through 80 mesh
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Bulk
          Density:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.50 -0.90 g/ml
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Content
          of Protein: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 6.0% max.
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Nitrogen:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          2.5 ~ 3.8%
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Specific
          Rotation:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -20.0°~ -30.0°
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Residue
          of Ignition:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 20%-30%
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Heavy
            Metals :
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;10ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Total
            Plate Count :
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;1.000ct/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Yeast
            and Molds :
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;100ct/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Total
            Coliforms :
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;100ct/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Escherichia
            coil :
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Absent</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Salmonalla
            species:
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Absent</span>
        </span>
      </p>
      <p>
        <u>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="text-decoration:none;">
              <br>
            </span>
          </span>
        </u>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Packing</span>
        </u>
        <span style="font-size:12px;font-family:Arial;">: 25kg per fiber drum</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lsrgs: require("../../../assets/img/common/lsrgs.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/product/lsrgs.vue